"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USStates = void 0;
var USStates;
(function (USStates) {
    USStates["Alabama"] = "AL";
    USStates["Alaska"] = "AK";
    USStates["AmericanSamoa"] = "AS";
    USStates["Arizona"] = "AZ";
    USStates["Arkansas"] = "AR";
    USStates["California"] = "CA";
    USStates["Colorado"] = "CO";
    USStates["Connecticut"] = "CT";
    USStates["Delaware"] = "DE";
    USStates["DistrictOfColumbia"] = "DC";
    USStates["FederatedStatesOfMicronesia"] = "FM";
    USStates["Florida"] = "FL";
    USStates["Georgia"] = "GA";
    USStates["Guam"] = "GU";
    USStates["Hawaii"] = "HI";
    USStates["Idaho"] = "ID";
    USStates["Illinois"] = "IL";
    USStates["Indiana"] = "IN";
    USStates["Iowa"] = "IA";
    USStates["Kansas"] = "KS";
    USStates["Kentucky"] = "KY";
    USStates["Louisiana"] = "LA";
    USStates["Maine"] = "ME";
    USStates["MarshallIslands"] = "MH";
    USStates["Maryland"] = "MD";
    USStates["Massachusetts"] = "MA";
    USStates["Michigan"] = "MI";
    USStates["Minnesota"] = "MN";
    USStates["Mississippi"] = "MS";
    USStates["Missouri"] = "MO";
    USStates["Montana"] = "MT";
    USStates["Nebraska"] = "NE";
    USStates["Nevada"] = "NV";
    USStates["NewHampshire"] = "NH";
    USStates["NewJersey"] = "NJ";
    USStates["NewMexico"] = "NM";
    USStates["NewYork"] = "NY";
    USStates["NorthCarolina"] = "NC";
    USStates["NorthDakota"] = "ND";
    USStates["NorthernMarianaIslands"] = "MP";
    USStates["Ohio"] = "OH";
    USStates["Oklahoma"] = "OK";
    USStates["Oregon"] = "OR";
    USStates["Palau"] = "PW";
    USStates["Pennsylvania"] = "PA";
    USStates["PuertoRico"] = "PR";
    USStates["RhodeIsland"] = "RI";
    USStates["SouthCarolina"] = "SC";
    USStates["SouthDakota"] = "SD";
    USStates["Tennessee"] = "TN";
    USStates["Texas"] = "TX";
    USStates["Utah"] = "UT";
    USStates["Vermont"] = "VT";
    USStates["VirginIslands"] = "VI";
    USStates["Virginia"] = "VA";
    USStates["Washington"] = "WA";
    USStates["WestVirginia"] = "WV";
    USStates["Wisconsin"] = "WI";
    USStates["Wyoming"] = "WY";
    USStates["OutsideTheUS"] = "..";
})(USStates = exports.USStates || (exports.USStates = {}));
//# sourceMappingURL=location.js.map